const MESSAGE_EVENT_TYPE = 'message';

export { MESSAGE_EVENT_TYPE };
